import { render, staticRenderFns } from "./DrugsAndGoods.vue?vue&type=template&id=71f45a6d"
import script from "./DrugsAndGoods.vue?vue&type=script&lang=js"
export * from "./DrugsAndGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports